/* La Sura - newsletter sign-up validation (snippets/lasura-signup-validate.liquid).
   Upgrades each Horizon email sign-up form on the page. See the snippet for what it does. */

const messages = (() => {
  try {
    return JSON.parse(document.getElementById('LasuraSignupMessages')?.textContent || '{}');
  } catch (error) {
    return {};
  }
})();

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ICON =
  '<svg viewBox="0 0 16 16" width="16" height="16" focusable="false"><circle cx="8" cy="8" r="7" fill="currentColor"/><path d="M7.2 4h1.6l-.2 5H7.4zM8 10.4a1 1 0 1 1 0 2 1 1 0 0 1 0-2" fill="var(--color-background)"/></svg>';

function problem(input) {
  const value = input.value.trim();
  if (!value) return 'missing';
  if (!EMAIL.test(value)) return 'format';
  return '';
}

function upgrade(form) {
  const input = form.querySelector('input[type="email"]');
  if (!input || form.dataset.lasuraSignup) return;
  form.dataset.lasuraSignup = 'on';

  /* The browser's own bubble would cover ours. Without this script, required and the
     email type still stop a bad send. */
  form.noValidate = true;

  const error = document.createElement('p');
  error.className = 'email-signup__message lasura-signup__error';
  error.id = `${input.id}-lasura-error`;
  error.hidden = true;
  error.innerHTML = `<span class="lasura-signup__error-icon" aria-hidden="true">${ICON}</span><span data-error-text></span>`;
  const group = input.closest('.email-signup__input-group') || input;
  group.after(error);

  /* Shopify's error after a reload, if there is one: it stays until the email is edited. */
  const serverError = form.querySelector('[id^="Email-signup__message-error-"]');

  const show = (kind) => {
    if (serverError) serverError.hidden = true;
    error.querySelector('[data-error-text]').textContent = kind ? messages[kind] || '' : '';
    error.hidden = !kind;
    if (kind) {
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', error.id);
    } else {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
  };

  let touched = false;
  input.addEventListener('input', () => {
    touched = true;
    if (input.getAttribute('aria-invalid') === 'true') show(problem(input));
  });
  input.addEventListener('blur', () => {
    if (touched) show(problem(input));
  });

  form.addEventListener(
    'submit',
    (event) => {
      const kind = problem(input);
      show(kind);
      if (!kind) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      input.focus();
    },
    { capture: true }
  );

  /* After a successful sign-up the page reloads at the form; the thank-you message takes
     focus so it's announced, not just shown. */
  const success = form.querySelector('[id^="Email-signup__message-success-"]');
  if (success && new URLSearchParams(location.search).has('customer_posted')) {
    success.focus({ preventScroll: true });
  }
}

document.querySelectorAll('form.email-signup__form').forEach(upgrade);

/* Sections added or changed in the theme editor. */
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('form.email-signup__form').forEach(upgrade);
});
